<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-browser`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 8a2 2 0 00-2-2H4a2 2 0 00-2 2v32a2 2 0 002 2h40a2 2 0 002-2V8zM6 12h36v26H6V12zm23 4a1 1 0 011 1v2a1 1 0 01-1 1H11a1 1 0 01-1-1v-2a1 1 0 011-1h18zm9 4v-4h-4v4h4z"/></svg>
</template>
<script>

export default {
  name: 'IconBrowser',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
